import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState(""); 

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_mfq10gm",
        "template_zv93fvp",
        form.current,
        "N1CvNyWIsnKIqXO2D"
      )
      .then(
        () => {
          setStatus("success");
          form.current.reset();
          setTimeout(() => setStatus(""), 3000); 
        },
        (error) => {
          console.log(error.text);
          setStatus("error"); 
          setTimeout(() => setStatus(""), 3000);
        }
      );
  };

  return (
    <>
      <div className="header1" style={{ backgroundImage: "url('/Image/back.avif')" }}>
        <div className="overlay1"></div>
        <div className="box">
          <h2>Contact Us </h2>
          <p>We're here to help. Reach out to us for any inquiries or assistance.</p>
        </div>
      </div>

      <section className="contact-address-area">
        <div className="container">
          <div className="sec-title-style1 text-center max-width">
            <div className="title">Contact Us</div>
            <div className="text">
              <div className="decor-left"><span></span></div>
              <p>Quick Contact</p>
              <div className="decor-right"><span></span></div>
            </div>
            <div className="bottom-text">
              <p>Narayani Solutions was founded with a vision to revolutionize the digital landscape by seamlessly integrating AI and cloud technologies.</p>
            </div>
          </div>

          <div className="contact-address-box row">
            <div className="col-sm-4 single-contact-address-box text-center">
              <div className="icon-holder">
                <span className="icon-clock-1"></span>
              </div>
              <h3>Narayani</h3>
              <h2> Solutions</h2>
            </div>

            <div className="col-sm-4 single-contact-address-box main-branch">
              <h3>Connect</h3>
              <div className="inner">
                <ul>
                  <li>
                    <div className="title">
                      <h4>Address:</h4>
                    </div>
                    <div className="text">
                      <p>
                        <b>Office 1:</b> IT-7 Building, Qubix Business Parks,
                        Phase 1, Hinjawadi, Pune, Maharashtra 411057
                      </p>
                      <p>
                        <b>Office 2:</b> #501, Shanti Heights,<br />
                        Manish Nagar, Nagpur - 440015,<br />
                        MAHARASHTRA, India
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="title"><h4>Mobile</h4></div>
                    <div className="text">
                      <p>+91-8530434964</p>
                      <p>+91-9986554887</p>
                    </div>
                  </li>
                  <li>
                    <div className="title"><h4>Email</h4></div>
                    <div className="text">
                      <p>Support@Narayanisolutions.com</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-sm-4 single-contact-address-box text-center">
              <div className="icon-holder">
                <span className="icon-question-2"></span>
              </div>
              <h3>Artificial Intelligence</h3>
              <h2> & Cloud Computing.</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-info-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="contact-form">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="sec-title-style1 float-left">
                      <div className="title4">If You Have Any Query, Please Feel Free Contact Us</div>
                      <div className="text">
                        <div className="decor-left"><span></span></div>
                        <p>Contact Form</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="inner-box">
                  <form
                    ref={form}
                    onSubmit={sendEmail}
                    id="contact-form"
                    name="contact_form"
                    className="default-form"
                  >
                    <div className="row">
                      <div className="col-xl-6 col-lg-12">
                        <div className="row">
                          <div className="col-xl-6">
                            <div className="input-box">
                              <input type="text" name="user_name" placeholder="Name" required />
                            </div>
                            <div className="input-box">
                              <input type="text" name="user_phone" placeholder="Phone" />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="input-box">
                              <input type="email" name="user_email" placeholder="Email" required />
                            </div>
                            <div className="input-box">
                              <input type="text" name="user_website" placeholder="Website" />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-xl-12">
                            <div className="input-box">
                              <input type="text" name="subject" placeholder="Subject" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-12">
                        <div className="input-box">
                          <textarea name="message" placeholder="Your Message..." required></textarea>
                        </div>

                        <div className="button-box">
                          <button type="submit">
                            Send Message
                            <span className="flaticon-next"></span>
                          </button>

                       
                          {status === "success" && (
                            <p style={{ color: "green", marginTop: "10px" }}>
                              Message sent successfully ✅
                            </p>
                          )}
                          {status === "error" && (
                            <p style={{ color: "red", marginTop: "10px" }}>
                              Failed to send ❌
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;